export default {
  main: '#5A2049',
  secondary: '#E51936',
  contrastingColor: '#ffffff',
  priceColor: '#5A2049',
  entryBackground: '#5A2049',
  menuBackgroundColor: '#ffffff',
  menuTextColor: '#000000',
};
